import { render } from "./App.vue?vue&type=template&id=68aecd60"
const script = {}

import "./App.vue?vue&type=style&index=0&id=68aecd60&lang=css"
import "./App.vue?vue&type=style&index=1&id=68aecd60&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__